import React from 'react';
import { ArrowRightIcon, TargetIcon, FileTextIcon, SparklesIcon, BarChart3Icon } from 'lucide-react';
import { type LearnIcon } from '../../data/webinarCommunications';
import { useWebinar } from '../../hooks/useWebinar';
import { trackEvent } from '../../utils/analytics';
const ICONS: Record<LearnIcon, typeof TargetIcon> = {
  target: TargetIcon,
  template: FileTextIcon,
  atna: SparklesIcon,
  analytics: BarChart3Icon
};
export function WebinarLearn() {
  const learnCopy = useWebinar().copy.learn;
  const learnCards = learnCopy.cards;
  return <section id="apprendre" aria-labelledby="learn-title" className="scroll-mt-[72px] bg-[#070A1C] border-t border-white/[0.06]" data-id="element-7916" data-mp="1xcrj4gf5dpsy">
      <div className="max-w-[1280px] mx-auto px-5 md:px-8 py-20 md:py-28" data-id="element-7917" data-mp="1nklspb4jngfv">
        <h2 id="learn-title" className="max-w-[46rem] font-serif text-[2rem] md:text-[2.6rem] leading-[1.12] tracking-tight text-white" data-id="element-7918" data-mp="1niisxzdla8xy">
          {learnCopy.title}
        </h2>

        <ul className="mt-14 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4" data-id="element-7919" data-mp="2g2hcr076c5ja">
          {learnCards.map(card => {
          const Icon = ICONS[card.icon];
          const isAtna = card.icon === 'atna';
          return <li key={card.title} className={`flex flex-col rounded-[20px] border p-6 md:p-7 ${isAtna ? 'border-[#4F46E5]/50 bg-[#131546]' : 'border-white/[0.08] bg-[#0C1029]'}`} data-id="element-7920" data-mp="3oo8kf5tzi6ta">
                <div className="flex items-center justify-between gap-3 min-h-[44px]" data-id="element-7921" data-mp="2g8udnr09mlr">
                  <span className={`inline-flex w-11 h-11 items-center justify-center rounded-xl ${isAtna ? 'bg-[#4F46E5] text-white' : 'bg-white/[0.06] text-[#A5A1FF]'}`} data-id="element-7922" data-mp="3tnuy1gdq5p2m">
                    <Icon className="w-5 h-5" aria-hidden="true" data-id="element-7923" data-mp="7g51hvv01u5j" />
                  </span>
                  {card.badge && <span className="rounded-full border border-[#A5A1FF]/40 px-2.5 py-1 font-sans text-[10px] font-semibold tracking-[0.12em] uppercase text-[#C7C4FF] whitespace-nowrap" data-id="element-7924" data-mp="2d8bhgdpb9md2">
                      {card.badge}
                    </span>}
                </div>
                <h3 className="mt-6 font-serif text-[1.35rem] leading-snug text-white" data-id="element-7925" data-mp="h5f2wpybqbe8">{card.title}</h3>
                <p className="mt-3 font-sans text-[14.5px] leading-relaxed text-[#A6ABC8]" data-id="element-7926" data-mp="m4i7k9ae6flo">{card.body}</p>
              </li>;
        })}
        </ul>

        <div className="mt-12" data-id="element-7927" data-mp="r1rw7mpyin8g">
          <a href="#inscription" onClick={() => trackEvent('webinar_cta_click', {
          location: 'learn'
        })} className="group inline-flex items-center gap-2 rounded-full border border-white/20 px-6 py-3.5 font-sans text-[15px] font-semibold text-white hover:border-[#A5A1FF] hover:bg-white/[0.04] transition-colors duration-150" data-id="element-7928" data-mp="v69gro4554ka">
            {learnCopy.cta}
            <ArrowRightIcon className="w-4 h-4 transition-transform duration-150 group-hover:translate-x-0.5" aria-hidden="true" data-id="element-7929" data-mp="1eu8osr7blxm0" />
          </a>
        </div>
      </div>
    </section>;
}